import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
const directionBody = `Welcome to Desert Sage Seminars!

FOR RETURNING STUDENTS: Please update your license expiration date in your Modify Profile folder on your Dashboard to clear the system for your NEW cycle

Where to Find Your Classes To Begin

*SELECT YOUR OWN package of (3 or 6) classes

Click on Available Classes folder
Click button in box to choose your class
Click on the Enroll Me button
Click on My Courses folder
Click on class Title to enter the class
Click the YOUR CLASS button to begin

*PRESET Package of (6 or 8) classes:
Click on My Classes folder
Click on class Title to enter the class
Click the YOUR CLASS button to begin

*SINGLE Class
Click on your My Classes folder
Click on class Title to enter class
Click on YOUR CLASS button to begin`;
export function EditDirectionText() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-703">
      <div className="flex items-center justify-between" data-id="element-704">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-705">
          Edit Direction Text
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/admin-area')} data-id="element-706">
          ← Back to Admin Area
        </Button>
      </div>

      <Card data-id="element-707">
        <CardContent className="pt-6" data-id="element-708">
          <form className="space-y-5" data-id="element-709">
            <Input label="Title" defaultValue="Direction" data-id="element-710" />

            <div data-id="element-711">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-712">
                Body
              </label>
              <div className="border border-slate-300 rounded-md overflow-hidden" data-id="element-713">
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-714">
                  <button type="button" className="px-1.5 py-0.5 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-715">
                    Source
                  </button>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-716" />
                  {['📄', '📋', '✂', '🗑', '↩', '↪'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-717">
                      {ic}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-718" />
                  {['🔍', '🔤', '🖊'].map((ic, i) => <button key={i} type="button" className="px-1 py-0.5 text-xs border border-transparent hover:border-slate-300 hover:bg-white rounded text-slate-500" data-id="element-719">
                      {ic}
                    </button>)}
                </div>
                <div className="flex items-center gap-0.5 px-2 py-1 bg-slate-100 border-b border-slate-300 flex-wrap" data-id="element-720">
                  {['B', 'I', 'U', 'S'].map(t => <button key={t} type="button" className="w-6 h-6 text-xs font-bold border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-700" data-id="element-721">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-722" />
                  {['≡', '≣', '❝', '»'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-723">
                      {t}
                    </button>)}
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-724" />
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-725">
                    <option data-id="element-726">Styles</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-727">
                    <option data-id="element-728">Format</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-729">
                    <option data-id="element-730">Font</option>
                  </select>
                  <select className="h-6 text-xs border border-slate-300 bg-white rounded px-1" data-id="element-731">
                    <option data-id="element-732">Size</option>
                  </select>
                  <span className="w-px h-4 bg-slate-300 mx-1" data-id="element-733" />
                  {['A', 'A', '⊞', '⊟', '⊕', '?'].map((t, i) => <button key={i} type="button" className="w-6 h-6 text-xs border border-slate-300 bg-white hover:bg-slate-50 rounded text-slate-600" data-id="element-734">
                      {t}
                    </button>)}
                </div>
                <textarea className="w-full p-3 text-sm focus:outline-none resize-y min-h-[300px] bg-white" defaultValue={directionBody} data-id="element-735" />
              </div>
            </div>

            <div className="pt-2" data-id="element-736">
              <Button type="submit" data-id="element-737">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}